<template>
    <div>
        <div style="margin:0 -12px;">
            <div class="luna-header-box">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-2">
                        </div>
                        <div class="col px-0 text-center">
                            <div style="padding-top:20px; ">
                                <b>申込フォーム確認画面</b>
                            </div>
                        </div>
                        <div class="col-2">
                        </div>
                    </div>
                </div>
            </div>
            <div class="wrap">
                <div class="container" style="margin-top:60px;">
                    <div class="row" style="background:#9990FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px;">
                            <div style="padding:0 10px;">
                                <small style="color:#fff;">フォーム１</small>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px;">
                            <div style="padding:0 10px;">
                                <small>イベント名</small>
                                <div style="padding:10px;background:#fff;border-radius: 6px;">
                                    {{ event_info.thumbnail }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px;">
                            <div style="padding:0 10px;">
                                <small>主催名</small>
                                <div style="padding:10px;background:#fff;border-radius: 6px;">
                                    {{ event_info.organizer }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px;">
                            <div style="padding:0 10px;">
                                <small>開催日時</small>
                                <div style="padding:10px;background:#fff;border-radius: 6px;">
                                    {{ event_info.event_at }}
                                    <div v-show="event_info.event_type_val > 0">
                                        1部<br>
                                        {{ event_info.event_at_from_1 }} 〜 {{ event_info.event_at_to_1 }}（開場 {{
                                            event_info.event_at_open_1 }}）
                                    </div>
                                    <div v-show="event_info.event_type_val > 1">
                                        2部<br>
                                        {{ event_info.event_at_from_2 }} 〜 {{ event_info.event_at_to_2 }}（開場 {{
                                            event_info.event_at_open_2 }}）
                                    </div>
                                    <div v-show="event_info.event_type_val > 2">
                                        3部<br>
                                        {{ event_info.event_at_from_3 }} 〜 {{ event_info.event_at_to_3 }}（開場 {{
                                            event_info.event_at_open_3 }}）
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px;">
                            <div style="padding:0 10px;">
                                <small>開催地域</small>
                                <div style="padding:10px;background:#fff;border-radius: 6px;">
                                    {{ event_info.area }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px;">
                            <div style="padding:0 10px;">
                                <small>開催住所</small>
                                <div style="padding:10px;background:#fff;border-radius: 6px;">
                                    {{ event_info.address }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px;">
                            <div style="padding:0 10px;">
                                <small>会場名</small>
                                <div style="padding:10px;background:#fff;border-radius: 6px;">
                                    {{ event_info.venue_name }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px;">
                            <div style="padding:0 10px;">
                                <small>定員・参加人数</small>
                                <div style="padding:10px;background:#fff;border-radius: 6px;">
                                    {{ event_info.member_count }}人
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px;">
                            <div style="padding:0 10px;">
                                <small>出演者・ゲスト名の登録</small>
                                <div style="padding:10px;background:#fff;border-radius: 6px;">
                                    <div v-for="(player, index) in event_info.players" :key="index">
                                        {{ player.value }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px;">
                            <div style="padding:0 10px;">
                                <small>サムネイル画像</small>
                                <div style="padding:10px;background:#fff;border-radius: 6px;">
                                    <img :src="event_info.img_url" class="img-fluid">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col" style="padding-top:10px;padding-bottom:10px;">
                            <div style="padding:10px;">
                                <a href="/event/entry/question1" style="font-size:12px;">
                                    <svg style="height:12px;width:12px;fill:#6B4EFF;margin-top:-2px">
                                        <use xlink:href="/images/<.svg#page_left"></use>
                                    </svg>&nbsp;修正する（フォーム１へ）</a>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="background:#9990FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px;">
                            <div style="padding:0 10px;">
                                <small style="color:#fff;">フォーム２</small>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px;">
                            <div style="padding:0 10px;">
                                <small>概要</small>
                                <div style="padding:10px;background:#fff;border-radius: 6px;">
                                    <div style="white-space: pre-wrap;font-size:12px;">{{ event_info.event_summary }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px;">
                            <div style="padding:0 10px;">
                                <small>こんな人におすすめ</small>
                                <div style="padding:10px;background:#fff;border-radius: 6px;">
                                    <div style="white-space: pre-wrap;font-size:12px;">{{ event_info.event_recommend }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px;">
                            <div style="padding:0 10px;">
                                <small>イベント詳細</small>
                                <div style="padding:10px;background:#fff;border-radius: 6px;">
                                    <div style="white-space: pre-wrap;font-size:12px;">{{ event_info.event_details }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px;">
                            <div style="padding:0 10px;">
                                <small>注意事項</small>
                                <div style="padding:10px;background:#fff;border-radius: 6px;">
                                    <div style="white-space: pre-wrap;font-size:12px;">{{ event_info.event_notes }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px;">
                            <div style="padding:0 10px;">
                                <small>決済方法</small>
                                <div style="padding:10px;background:#fff;border-radius: 6px;">
                                    当日決済
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px;">
                            <div style="padding:0 10px;">
                                <small>費用</small>
                                <div style="padding:10px;background:#fff;border-radius: 6px;">
                                    <div v-show="event_info.event_type_val > 1">
                                        <div class="row" style="padding-top:10px">
                                            <div class="col">
                                                1部<br>
                                                男性:{{ event_info.amount1 }}円<br>
                                                女性:{{ event_info.amount2 }}円
                                            </div>
                                        </div>
                                    </div>
                                    <div v-show="event_info.event_type_val > 1">
                                        <div class="row" style="padding-top:10px">
                                            <div class="col">
                                                2部<br>
                                                男性:{{ event_info.amount3 }}円<br>
                                                女性:{{ event_info.amount4 }}円
                                            </div>
                                        </div>
                                    </div>
                                    <div v-show="event_info.event_type_val > 2">
                                        <div class="row" style="padding-top:10px">
                                            <div class="col">
                                                3部<br>
                                                男性:{{ event_info.amount5 }}円<br>
                                                女性:{{ event_info.amount6 }}円
                                            </div>
                                        </div>
                                    </div>
                                    <div v-show="event_info.event_type_val > 0">
                                        <div class="row" style="padding-top:10px">
                                            <div class="col">
                                                通し<br>
                                                男性:{{ event_info.amount7 }}円<br>
                                                女性:{{ event_info.amount8 }}円
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px;">
                            <div style="padding:0 10px;">
                                <small>チケットの設定</small>
                                <div style="padding:10px;background:#fff;border-radius: 6px;">
                                    先着制
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col" style="padding-top:10px;padding-bottom:10px;">
                            <div style="padding:10px;">
                                <a href="/event/entry/question2" style="font-size:12px;">
                                    <svg style="height:12px;width:12px;fill:#6B4EFF;margin-top:-2px">
                                        <use xlink:href="/images/<.svg#page_left"></use>
                                    </svg>&nbsp;修正する（フォーム２へ）</a>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="background:#9990FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px;">
                            <div style="padding:0 10px;">
                                <small style="color:#fff;">フォーム３</small>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px;">
                            <div style="padding:0 10px;">
                                <small>お問い合わせ先メールアドレス</small>
                                <div style="padding:10px;background:#fff;border-radius: 6px;">
                                    {{ event_info.customer_mail }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col" style="padding-top:10px;padding-bottom:10px;">
                            <div style="padding:10px;">
                                <a href="/event/entry/question3" style="font-size:12px;">
                                    <svg style="height:12px;width:12px;fill:#6B4EFF;margin-top:-2px">
                                        <use xlink:href="/images/<.svg#page_left"></use>
                                    </svg>&nbsp;修正する（フォーム３へ）</a>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px;">
                            <div style="padding:0 10px;">
                                <small>公開状態を選択</small>
                                <v-select name="open_status" :options="open_status_list" v-model="open_status"
                                    placeholder="選択してください">
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center" style="background:#E7E7FF;">
                        <div class="col-9">
                            <br />
                            <div class="d-grid gap-2">
                                <button type="button" class="btn btn-luna disabled" style="padding: 12px 0" v-if="is_load">
                                    <div class="spinner-border" style="width: 1rem; height: 1rem;" role="status"
                                        v-if="is_load">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                    <div style="font-size:10px;">公開状態を設定して</div>
                                    イベントを作成
                                </button>
                                <button type="button" class="btn btn-luna" style="padding: 12px 0" @click="setEvent()"
                                    id="on-btn" v-else-if="open_status != null">
                                    <div style="font-size:10px;">公開状態を設定して</div>
                                    イベントを作成
                                </button>
                                <button type="button" class="btn btn-luna-d disabled" style="padding: 12px 0" id="non-btn"
                                    v-else>
                                    <div style="font-size:10px;">公開状態を設定して</div>
                                    イベントを作成
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col text-center">
                            <br>
                            <br>
                            <div style="font-size:12px;">
                                インターネット異性紹介事業 届出済<br>
                                登録番号 30240011-000
                            </div>
                            <br>
                            <br>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { hasValidRequiredEventTexts, normalizeRequiredEventTextFields, normalizeText } from "../../../helpers/eventText";

export default {
    data() {
        return {
            is_load: false,

            event_info: {},
            open_status: { value: "0", label: "非公開" },

            open_status_list: [
                { value: "0", label: "非公開" },
                { value: "1", label: "受付準備中で公開" },
                { value: "2", label: "募集中で公開" },
                { value: "3", label: "申込締切で公開" },
                { value: "4", label: "開催中止で公開" },
            ],
        };
    },
    methods: {
        initEvent() {
            if (localStorage.getItem('luna_event_entry') !== null) {
                let serializedArray = localStorage.getItem('luna_event_entry');
                let event = JSON.parse(serializedArray);

                this.event_info = event
            }
        },
        rmEventInfo() {
            if (localStorage.getItem('luna_event_entry') !== null) {
                localStorage.removeItem('luna_event_entry')
            }
        },
        async setEvent() {
            this.is_load = true

            if (this.event_info == null || this.event_info['event_type'] == null || this.event_info['is_player'] == null) {
                this.is_load = false
                this.$showErrorToast("入力内容を確認してください")
                window.location.href = "/event/entry/question1"
                return
            }

            const eventTexts = normalizeRequiredEventTextFields(this.event_info)

            if (!hasValidRequiredEventTexts(eventTexts)) {
                this.is_load = false
                this.$showErrorToast("イベント説明の入力内容を確認してください")
                window.location.href = "/event/entry/question2"
                return
            }

            let event_to_time = null
            const thumbnail = normalizeText(this.event_info['thumbnail'])
            const address = normalizeText(this.event_info['address'])
            const organizer = normalizeText(this.event_info['organizer'])
            const venueName = normalizeText(this.event_info['venue_name'])
            const eventFeature = normalizeText(this.event_info['event_feature'])
            const area = normalizeText(this.event_info['area'])
            const customerMail = normalizeText(this.event_info['customer_mail'])
            const players = Array.isArray(this.event_info['players']) ? this.event_info['players'] : []
            const isPlayer = (this.event_info['is_player'] == null) ? 0 : this.event_info['is_player']['value']

            if (this.event_info['event_type']['value'] == 0) {
                event_to_time = this.event_info['event_at_to_1']
            }
            else if (this.event_info['event_type']['value'] == 1) {
                event_to_time = this.event_info['event_at_to_2']
            }
            else if (this.event_info['event_type']['value'] == 2) {
                event_to_time = this.event_info['event_at_to_3']
            }

            await axios
                .post("/api/event/entry", {
                    thumbnail: thumbnail,
                    event_at_from: this.event_info['event_at'] + ' ' + this.event_info['event_at_from_1'] + ':00',
                    event_at_to: this.event_info['event_at'] + ' ' + event_to_time + ':00',
                    event_at_from_1: this.event_info['event_at'] + ' ' + this.event_info['event_at_from_1'] + ':00',
                    event_at_to_1: this.event_info['event_at'] + ' ' + this.event_info['event_at_to_1'] + ':00',
                    event_at_open_1: this.event_info['event_at'] + ' ' + this.event_info['event_at_open_1'] + ':00',
                    event_at_from_2: this.event_info['event_at'] + ' ' + this.event_info['event_at_from_2'] + ':00',
                    event_at_to_2: this.event_info['event_at'] + ' ' + this.event_info['event_at_to_2'] + ':00',
                    event_at_open_2: this.event_info['event_at'] + ' ' + this.event_info['event_at_open_2'] + ':00',
                    event_at_from_3: this.event_info['event_at'] + ' ' + this.event_info['event_at_from_3'] + ':00',
                    event_at_to_3: this.event_info['event_at'] + ' ' + this.event_info['event_at_to_3'] + ':00',
                    event_at_open_3: this.event_info['event_at'] + ' ' + this.event_info['event_at_open_3'] + ':00',
                    recruit_at_from: null,
                    recruit_at_to: null,
                    member_count: this.event_info['member_count'],
                    address: address,
                    organizer: organizer,

                    amount2: 0,
                    amount1: 0,
                    amount4: this.event_info['amount7'],
                    amount3: this.event_info['amount8'],
                    amount6: null,
                    amount5: null,
                    amount8: this.event_info['amount1'],
                    amount7: this.event_info['amount2'],
                    amount10: null,
                    amount9: null,
                    amount12: this.event_info['amount3'],
                    amount11: this.event_info['amount4'],
                    amount14: null,
                    amount13: null,
                    amount16: this.event_info['amount5'],
                    amount15: this.event_info['amount6'],
                    amount18: null,
                    amount17: null,
                    amount19: this.event_info['amount8'],
                    amount20: this.event_info['amount7'],

                    event_type: this.event_info['event_type']['value'],
                    venue_name: venueName,
                    ...eventTexts,
                    event_feature: eventFeature,
                    address_view: area,
                    catch_copy: '',
                    customer_mail: customerMail,

                    img_url: this.event_info['img_url'],
                    players: players,
                    is_player: isPlayer,
                    open_status: this.open_status.value,
                })
                .then((response) => {

                    if (localStorage.getItem('luna_event_entry') !== null) {
                        localStorage.removeItem('luna_event_entry')
                    }

                    window.location.href = "/event/home"
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("イベントの作成に失敗しました")
                    }
                }).finally(() => {
                    this.is_load = false
                })
        },
        async isAuth() {
            await axios.get("/api/auth/user/get")
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.isAuth()
                            this.initEvent()
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    })
            }
            else {
                this.isAuth()
                this.initEvent()
            }
        }
        else {
            this.isAuth()
            this.initEvent()
        }
    },
};
</script>

<style scoped>
.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    height: 56px;
    width: 540px;
    background-color: #fff;
    z-index: 999;
}


@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}

small {
    color: #5538EE;
}

.vs__dropdown-toggle {
    background-color: #fff;

}

.vs__dropdown-toggle {
    background-color: #fff;
}
</style>
